// Leitura da sessão guardada no navegador — sem React, para caber no pacote do site.

/**
 * Existe uma sessão que ainda vale?
 *
 * ⚠️ `isAuthenticated` DO AuthContext É SÓ "HÁ UM TOKEN GUARDADO" (`!!token`), sem olhar
 * a validade. Usá-lo para escolher a tela mandava quem tinha entrado no app semanas atrás
 * para /inbox → a API recusava o token vencido → /login. Resultado: quem já foi cliente
 * NUNCA mais via a landing no domínio do site. Medido no navegador em 24/09/2026.
 *
 * Lemos o `exp` do JWT só para decidir QUAL TELA mostrar — não é autenticação: a API
 * continua sendo quem aceita ou recusa o token. Token ilegível conta como sem sessão,
 * porque o custo do erro é mostrar a landing a alguém logado (um clique em "Entrar"),
 * e o contrário prende um visitante no login.
 */
export function sessaoValida(token, agora = Date.now()) {
  if (!token || typeof token !== "string") return false;
  const partes = token.split(".");
  if (partes.length !== 3) return false;
  try {
    const b64 = partes[1].replace(/-/g, "+").replace(/_/g, "/");
    const carga = JSON.parse(atob(b64.padEnd(b64.length + ((4 - (b64.length % 4)) % 4), "=")));
    // Sem `exp` o token não diz quando vence: tratamos como válido, e a API decide.
    if (carga.exp == null) return true;
    return Number(carga.exp) * 1000 > agora;
  } catch {
    return false;
  }
}

/** O token nos MESMOS lugares em que o AuthContext procura (auth.token, token, authToken). */
export function tokenGuardado(storage = typeof window !== "undefined" ? window.localStorage : null) {
  try {
    if (!storage) return null;
    let auth = null;
    try { auth = JSON.parse(storage.getItem("auth") || "null"); } catch { auth = null; }
    return auth?.token || storage.getItem("token") || storage.getItem("authToken") || null;
  } catch {
    return null;
  }
}
